import { SharePermissions } from 'nextcloud-api';
import { Builder } from '../helpers/builder';
import { store } from '../store';
import {
    selectFilesToUpload,
    selectDestinationFolderPath,
} from '../store/selectors/app';
import { selectTeamsContext } from '../store/selectors/conversation';
import { selectCircles, selectShares } from '../store/selectors/nextcloud';
import { selectDefaultFolderPath } from '../store/selectors/defaultFolder';
import { Circle } from '../services/microsoft/msGraphApi';

export type ShareWithCircleData = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    files: any[];
    permissions: SharePermissions;
    preselectedCircle?: Circle;
    isDropdownDisabled?: boolean;
};

export const getIntialCircleShareValues = (): ShareWithCircleData => {
    const state = store.getState();
    const teamsContext = selectTeamsContext(state);
    const circles = selectCircles(state);
    const destinationFolderPath = selectDestinationFolderPath(state);
    const defaultFolderPath = selectDefaultFolderPath(state);
    const shares = selectShares(state);

    const builder = Builder.of<ShareWithCircleData>();

    const isChannelOrTeam = Boolean(
        teamsContext?.channel?.id || teamsContext?.team?.groupId,
    );

    let preselectedCircle: Circle | undefined;
    let isDropdownDisabled = false;

    if (
        isChannelOrTeam &&
        destinationFolderPath === defaultFolderPath &&
        destinationFolderPath &&
        defaultFolderPath
    ) {
        const sharedCirclesWithAllGrants = shares
            .filter((share) => share.permissions === SharePermissions.All)
            .map((share) => share.share_with);

        preselectedCircle = circles.find((circle) =>
            sharedCirclesWithAllGrants.includes(circle.id),
        );

        if (preselectedCircle) {
            isDropdownDisabled = true;
        }
    }

    return builder
        .addOrReplace('files', selectFilesToUpload(state))
        .addOrReplace('permissions', SharePermissions.Read)
        .addOrReplace('preselectedCircle', preselectedCircle)
        .addOrReplace('isDropdownDisabled', isDropdownDisabled)
        .build();
};
